/* ez-yt-facade.js — click-to-load facade for YouTube iframes pasted into the article body.
   Blog posts (article.content) embed live <iframe src="youtube.com/embed/…"> which each pull the
   full YouTube player (~1MB+ JS) on load; the hotspot article shipped 4 of them (~4.7MB JS, 22s
   mobile LCP). This scans .ez-art__body, swaps each YouTube iframe for a lightweight poster + play
   affordance (matching ez-video-feature's lite embed), and injects the real iframe only on click —
   zero third-party YouTube JS/network until the visitor asks. Playlist embeds (videoseries/playlist
   pseudo-ids) have no single-frame thumbnail, so they fall back to a branded placeholder; the full
   original src (incl. ?list=…&rel=…) is preserved verbatim and reused on click. */
(function () {
  'use strict';

  var YT_RE = /(?:youtube(?:-nocookie)?\.com\/embed\/|youtu\.be\/)([\w-]+)/;

  function videoId(src) {
    var m = src.match(YT_RE);
    return m ? m[1] : null;
  }

  function posterUrl(id) {
    // playlist embeds have no single-video thumbnail → branded hatch placeholder instead
    if (!id || id === 'videoseries' || id === 'playlist') return null;
    return 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
  }

  function play(facade) {
    if (facade.getAttribute('data-loaded') === '1') return;
    facade.setAttribute('data-loaded', '1');

    var src = facade.getAttribute('data-src');
    var title = facade.getAttribute('data-title') || 'Video';
    src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';

    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', src);
    iframe.setAttribute('title', title);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('loading', 'lazy');

    var frame = document.createElement('span');
    frame.className = 'ez-art__ytframe';
    frame.appendChild(iframe);
    facade.parentNode.replaceChild(frame, facade);
    try { iframe.focus(); } catch (e) {}
  }

  function build(iframe) {
    var src = iframe.getAttribute('src') || '';
    if (!YT_RE.test(src)) return;
    var poster = posterUrl(videoId(src));

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ez-art__ytfacade';
    btn.setAttribute('data-src', src);
    btn.setAttribute('data-title', iframe.getAttribute('title') || 'Play video');
    btn.setAttribute('aria-label', 'Play video');

    var html = poster
      ? '<img class="ez-art__ytposter" src="' + poster + '" alt="" loading="lazy" decoding="async">'
      : '<span class="ez-art__ytposter ez-art__ytposter--ph" aria-hidden="true"></span>';
    html += '<span class="ez-art__ytscrim" aria-hidden="true"></span>';
    html += '<span class="ez-art__ytplay" aria-hidden="true"><svg width="20" height="24" viewBox="0 0 20 24" fill="none"><path d="M2 2L18 12L2 22V2Z" fill="currentColor"/></svg></span>';
    btn.innerHTML = html;

    btn.addEventListener('click', function () { play(btn); });
    iframe.parentNode.replaceChild(btn, iframe);
  }

  function init() {
    var frames = document.querySelectorAll('.ez-art__body iframe');
    for (var i = 0; i < frames.length; i++) {
      if (YT_RE.test(frames[i].getAttribute('src') || '')) build(frames[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
